import { sql } from "drizzle-orm"
import { type AnyPgColumn, pgTable, timestamp, uniqueIndex, uuid } from "drizzle-orm/pg-core"
import { assets } from "./asset"
import { companies } from "./company"
import { contacts } from "./contact"
import { documents } from "./document"
import { insurances } from "./insurance"
import { journals } from "./journal"
import { tasks } from "./task"
import { trusts } from "./trust"

// Purpose: Provides a many-to-many link between a journal entry and various resources.
export const journalResource = pgTable(
  "journal_resource",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    journalId: uuid("journal_id")
      .notNull()
      .references(() => journals.id, { onDelete: "cascade" }),
    assetId: uuid("asset_id").references(() => assets.id, { onDelete: "cascade" }),
    taskId: uuid("task_id").references(() => tasks.id, { onDelete: "cascade" }),
    contactId: uuid("contact_id").references(() => contacts.id, { onDelete: "cascade" }),
    documentId: uuid("document_id").references(() => documents.id, { onDelete: "cascade" }),
    companyId: uuid("company_id").references(() => companies.id, { onDelete: "cascade" }),
    trustId: uuid("trust_id").references((): AnyPgColumn => trusts.id, { onDelete: "cascade" }),
    insuranceId: uuid("insurance_id").references((): AnyPgColumn => insurances.id, {
      onDelete: "cascade",
    }),
    createdAt: timestamp("created_at").defaultNow().notNull(),
    // Note: For 'ON UPDATE CURRENT_TIMESTAMP' functionality in PostgreSQL,
    // a database trigger is required. This schema sets the timestamp on creation,
    // and application logic or a trigger should handle updates.
    updatedAt: timestamp("updated_at").defaultNow().notNull(),
  },
  (table) => [
    uniqueIndex("journal_resource_journal_trust_uq")
      .on(table.journalId, table.trustId)
      .where(sql`${table.trustId} is not null`),
    uniqueIndex("journal_resource_journal_insurance_uq")
      .on(table.journalId, table.insuranceId)
      .where(sql`${table.insuranceId} is not null`),
  ],
)
